import { c as _c } from "react/compiler-runtime";
import { Link } from "@opensea/next-ui-kit";
import { TextBody } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { PRIVACY_POLICY_URL } from "@/constants/constants";
export function PageFooterPrivacyPolicy() {
  const $ = _c(4);
  const t = useTranslations("PageFooterPrivacyPolicy");
  let t0;
  if ($[0] !== t) {
    t0 = t("privacyPolicy");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <Link className="-mt-[4px]" href={PRIVACY_POLICY_URL} variant="unstyled"><TextBody color="text-secondary" size="xs">{t0}</TextBody></Link>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}